import {React }from 'react'
import Checkout from '../../components/Checkout/Checkout'

function CheckoutView() {
  return (
      <Checkout></Checkout>
  )
}

export default CheckoutView